import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/SPA"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99944 10.5159C7.72282 8.92312 5.36708 6.56562 5.04464 6.26257C5.34946 4.00021 6.42602 1.98277 7.99944 0.485107C9.57463 1.98453 10.6494 4.00198 10.9542 6.26433C10.6318 6.56562 8.27607 8.92488 7.99944 10.5159ZM7.94119 15.8004C5.72818 15.5943 3.59621 14.5318 2.08621 12.6677C0.549782 10.7718 -0.0422364 8.41957 0.250249 6.17836C2.13731 6.32813 3.97326 7.10339 5.42159 8.46362C5.70175 8.72792 5.9678 9.01335 6.218 9.3217C7.16946 10.4952 7.75971 11.8448 8.0011 13.235C8.24249 11.8448 8.83274 10.4952 9.7842 9.3217C10.0326 9.01512 10.3005 8.72968 10.5806 8.46539C12.0289 7.10339 13.8649 6.32989 15.752 6.17836C16.0409 8.41957 15.4489 10.7718 13.9125 12.6677C12.4025 14.53 10.2705 15.5943 8.05748 15.8004C8.04309 15.8004 8.03014 15.8019 8.01601 15.8035L8.01167 15.8039C8.00639 15.8057 8.00286 15.8057 7.99934 15.8057C7.99405 15.8039 7.99053 15.8039 7.987 15.8039C7.97261 15.8039 7.95966 15.8025 7.94553 15.8009L7.94119 15.8004Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { SPA16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var SPA16 = createIcon(IconComponent);